import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { TwoColumnGrid } from "../../_shared-components/arrangement/TwoColumnGrid";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import { PaymentMethods } from "./PaymentMethods";
import React from "react";
import { FooterData, FooterSection } from "@swo/storefront";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

export const FooterSimplifiedTop: ReactTFC<{
  paymentMethods: FooterData["paymentMethods"];
  links: FooterSection;
}> = props => {
  return (
    <TwoColumnGrid
      ratio={[1, 1]}
      atLeast={"md"}
      container={"--max-content-width-new"}
      attachStyles={css`
        padding: 30px 0;
        ${CSS_MQ.atLeastMd} {
          padding: 25px 0;
        }
      `}
    >
      <div
        css={css`
          ${CSS_MQ.atMostSm} {
            margin-bottom: 30px;
            display: flex;
            flex-direction: column;
          }

          ${CSS_MQ.atLeastMd} {
            max-width: 80%; // just to force wrapping to second line

            margin-top: -10px;
            margin-bottom: -10px;
          }
        `}
      >
        {props.links.map(link => {
          return (
            <SwarovskiLink
              key={JSON.stringify(link)}
              link={link.link}
              isInternal={true}
              scrollToTop
              attachStyles={[
                FONTS.SwarovskiFutura300,
                fontSize.x2s,
                css`
                  ${CSS_MQ.atMostSm} {
                    &:not(:last-of-type) {
                      margin-bottom: 20px;
                    }
                  }

                  ${CSS_MQ.atLeastMd} {
                    display: inline-block;

                    padding-top: 10px;
                    padding-bottom: 10px;

                    margin-right: 20px;
                  }

                  color: ${CSS_COLORS.White};

                  text-transform: uppercase;
                  text-decoration: none;
                  &:hover {
                    text-decoration: underline;
                  }
                `,
              ]}
            >
              {link.label}
            </SwarovskiLink>
          );
        })}
      </div>

      <PaymentMethods data={props.paymentMethods} />
    </TwoColumnGrid>
  );
};
